import React, { lazy } from 'react';
import { RouteObject } from 'react-router';
import { RouteConstants } from '../constants/RouteConstants';
import { Navigate } from 'react-router-dom';

const Home = lazy(() => import('../components/Home'));
const Investigations = lazy(() => import('../components/routes/Investigations'));
const AuthenticatedApp = lazy(() => import('../components/AuthenticatedApp'));
const LoginRoute = lazy(() => import('../modules/LoginRoute'));
const LoginCallback = lazy(() => import('../components/LoginCallback'));
const Prospect = lazy(() => import('../components/routes/prospect'));
const InvstForm = lazy(() => import('../components/routes/invstForm'));
const Base = lazy(() => import('../components/Base'));
const PlaceInputDemo = lazy(() => import('../components/./PlaceInputDemo'));
const InvestigationsFormContextProvider = lazy(
  () => import('../components/investigations/investigation-form/InvestigationFormContextProvider'),
);
const Libraries = lazy(() => import('../components/Libraries/Libraries'));
const ReviewCommitteeForm = lazy(() => import('../components/routes/ReviewCommitteeForm'));
const InvestigationDocuments = lazy(() => import('../components/investigations/InvestigationDocuments'));
const Users = lazy(() => import('../components/routes/Users'));
const UserSettingsProvider = lazy(() => import('../contexts/UserSettingsContext'));
const UserProfileView = lazy(() => import('../components/routes/UserProfile'));
const routes: RouteObject[] = [
  {
    path: '/place-demo',
    element: <PlaceInputDemo />,
  },
  {
    path: RouteConstants.BASE,
    element: <AuthenticatedApp />,
    children: [
      {
        path: RouteConstants.BASE,
        element: <Base />,
      },
      {
        path: RouteConstants.HOME,
        element: <Home />,
      },
      {
        path: RouteConstants.INVESTIGATIONS,
        element: <Investigations />,
      },
      {
        path: `${RouteConstants.INVSTFORM}/:formId`,
        element: (
          <InvestigationsFormContextProvider>
            <InvstForm />
          </InvestigationsFormContextProvider>
        ),
      },
      {
        path: `${RouteConstants.PROSPECT}/:playerId`,
        element: <Prospect />,
      },
      {
        path: RouteConstants.REVIEW_COMMITTEE_MEETING,
        element: <ReviewCommitteeForm />,
      },
      {
        path: RouteConstants.INVESTIGATION_DOCUMENTS,
        element: <InvestigationDocuments />,
      },
      {
        path: RouteConstants.LIBRARIES,
        element: <Libraries />,
      },
      {
        path: RouteConstants.USERS,
        element: (
          <UserSettingsProvider>
            <Users />
          </UserSettingsProvider>
        ),
      },
      {
        path: `${RouteConstants.USERS}/:userId`,
        element: <UserProfileView />,
      },
      {
        path: RouteConstants.REPORTS,
        element: <Home />,
      },
    ],
  },
  {
    path: RouteConstants.LOGIN,
    element: <LoginRoute />,
  },
  {
    path: RouteConstants.LOGIN_CALLBACK,
    element: <LoginCallback />,
  },
  {
    path: RouteConstants.WILDCARD,
    // TODO Not Found Page
    element: <Navigate to={RouteConstants.LOGIN} />,
  },
];

export default routes;
